export default __webpack_public_path__ + "static/media/parthib associates.64583cfc.png";